import { getPrescription, getPrescriptionOrder } from 'Redux/modules/webChat/actions';
import { useCallback } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';

const useGetPrescription = () => {
  const {
    data: prescription,
    status,
    error,
    prescriptionOrder,
  } = useSelector(state => state.webChat.prescription, shallowEqual);

  const dispatch = useDispatch();
  const loading = status.details === 0 || status.prescriptionOrder === 0;
  const getPrescriptionDetails = useCallback(
    id => {
      dispatch(getPrescription(id));
    },
    [dispatch],
  );
  const getPrescriptionOrderDetails = useCallback(
    id => {
      dispatch(getPrescriptionOrder(id));
    },
    [dispatch],
  );

  return {
    prescription,
    loading,
    prescriptionOrder,
    getPrescriptionDetails,
    getPrescriptionOrderDetails,
    error: error?.details,
  };
};

export default useGetPrescription;
